import { defineStore } from 'pinia'
import { ref } from 'vue'

export type NotificationType = 'info' | 'error' | 'warning' | 'success'
export type Notification = {
  id?: number
  type: NotificationType
  message: string
  headline?: string
  closeable?: boolean
  actions?: Array<{ title: string; handler: () => void }>
}

let nextNotificationId = 1

export const persistKey = 'omr-manage-notification'
export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref<Notification[]>([])

  function addNotification(notification: Notification) {
    const newNotification = {
      ...notification,
      id: nextNotificationId++,
    }
    notifications.value.push(newNotification)
    return newNotification
  }
  function removeNotification(notificationToRemove: number) {
    notifications.value = notifications.value.filter((notification) => notification.id !== notificationToRemove)
  }

  return {
    addNotification,
    notifications,
    removeNotification,
  }
})
